<template>
  <div>
    <v-list-item v-if="typeof item.if !== 'undefined' && item.if" :href="item.href" :to="item.to">
      <v-list-item-title>{{ item.title }}</v-list-item-title>
    </v-list-item>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style></style>
